// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SocialInstagramComponent} from './SocialInstagram.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSocialInstagram = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SocialInstagramComponent/>
  </Icon>
));
